export const preloadFont = async (url: string, name: string): Promise<FontFace> => {
    // @ts-ignore because FontFace is experimental or whatever
    if (!FontFace) {
        return Promise.reject()
    }

    // @ts-ignore because FontFace is experimental or whatever
    const fontFace = new FontFace(name, `url(${url})`)
    ;(document as any).fonts.add(fontFace)
    return fontFace.load()
}

export const preloadImage = (url: string): Promise<HTMLImageElement> =>
    new Promise((resolve, reject) => {
        const img = document.createElement('img')
        img.onerror = () => reject()
        img.onload = () => {
            resolve(img)
        }
        img.crossOrigin = 'anonymous'
        img.src = url
    })

export const preloadVideo = (url: string): Promise<HTMLVideoElement> =>
    new Promise((resolve, reject) => {
        const video = document.createElement('video')
        video.onerror = () => reject()
        video.onload = () => {
            resolve(video)
        }
        video.preload = 'auto'
        video.src = url
    })
